import { createContext, useContext } from "react";
import { useConfig } from "./config-context.js";
const FieldInitialDataContext = createContext(void 0);
const useFieldInitialData = (fieldType) => {
  const context = useContext(FieldInitialDataContext);
  const { isEditor, isComposer } = useConfig();
  if (isEditor || isComposer) {
    return {};
  }
  if (context === void 0) {
    throw new Error(
      "useFieldInitialData must be used within a FieldInitialDataContext"
    );
  }
  return context[fieldType];
};
export {
  FieldInitialDataContext,
  useFieldInitialData
};
//# sourceMappingURL=field-initial-data-context.js.map
